import { render, staticRenderFns } from "./ExpiredToken.vue?vue&type=template&id=5897f62c&scoped=true"
import script from "./ExpiredToken.vue?vue&type=script&lang=js"
export * from "./ExpiredToken.vue?vue&type=script&lang=js"
import style0 from "./ExpiredToken.vue?vue&type=style&index=0&id=5897f62c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5897f62c",
  null
  
)

export default component.exports